module.exports = __webpack_public_path__ + "static/media/12x12-2.22df1fd9.png";